import { FC, PropsWithChildren } from "react";
import { Body } from "../../../typography";
import { BaseProps } from "../../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../../utilities/getHtmlPropsFromBaseProps";
import { createComponentStyleHook } from "../../../tokens";
import { getStyleModeSafeProps } from "../../utils/getStyleModeSafeProps";
import tokenStyles from "./styles.module.css";
import legacyStyles from "./styles.module.scss";

/**
 * The `Instructions` component properties.
 */

export interface InstructionsProps extends BaseProps {
  /**
   * The ID of the component the instructions belong to.
   */
  readonly forId?: string;
}

const useResolvedInstructionsStyles = createComponentStyleHook<InstructionsProps>({
  legacyStyles,
  tokenStyles,
  componentTokens: "form_instructions",
});

/**
 * An input component instructions block.
 */
export const Instructions: FC<PropsWithChildren<InstructionsProps>> = (props) => {
  const { children, forId } = props;
  const { mode, styles, StyleModeBoundary } = useResolvedInstructionsStyles(getStyleModeSafeProps(props));

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.Instructions, "instructions"],
    testIdPrefix: "instructions",
  });

  if (!children) return null;

  return (
    <StyleModeBoundary mode={mode}>
      <Body
        forId={forId ? `${forId}-instructions` : undefined}
        {...getBasePropsFromHtmlProps(baseHtmlProps)}
        inline
        size="mini"
      >
        {children}
      </Body>
    </StyleModeBoundary>
  );
};
